import React from 'react';
import "./dataRefreshTriggers.scss";

//Imagens:
import ImgDataRefresh from "../../../../assets/realtimeData/dataRefreshTriggers.png"
import { useTranslation } from 'react-i18next';

function DataRefreshTriggers() {
  const { t } = useTranslation()

  return (
    <div className='container-data-refresh'>
      <div className='img-data-refresh'>
        <img src={ImgDataRefresh} alt="" />
      </div>
      <div className='texts-data-refresh'>
        <h1>{t("realtime_data.triggers.title")}</h1>
        <p>{t("realtime_data.triggers.section_text_1")}</p>
        <p>{t("realtime_data.triggers.section_text_2")}</p>
      </div>
    </div>
  )
}

export default DataRefreshTriggers;